import Toastify from 'toastify-js'
import '../css/components/_toastify.css'

// For the options API, see https://github.com/apvarun/toastify-js/blob/master/README.md#api
window.toast = function (message, level, options = {}) {

    if (options.nextPage) {
        delete options.nextPage
        window.sessionStorage.setItem('toast', JSON.stringify({message, level, options}))
        return
    }

    if (options.delay) {
        const delay = options.delay
        delete options.delay
        setTimeout(() => window.toast(message, level, options), delay)
        return
    }

    const config = Object.assign({
        text: `<span>${message}</span>`, // <span> is required to style the close button properly
        duration: (options.hasOwnProperty('close') && options['close']) ? -1 : 5000, // Persist when the toast has a close button, otherwise vanish after 5 secs
        className: 'rounded-lg! px-4! py-3!',
        close: false,
        backgroundColor: {
            'success': '#059669',
            'warning': '#D97706',
            'error': '#DC2626',
        }[level] ?? '#059669',
        gravity: 'bottom', // `top` or `bottom`
        position: 'center', // `left`, `center` or `right`
        escapeMarkup: false,
        stopOnFocus: true, // Prevents dismissing of toast on hover
        onClick: function () { }, // Callback after click
        style: null,
        oldestFirst: true,
    }, options)

    Toastify(config).showToast()
}

window.addEventListener('DOMContentLoaded', (event) => {
    if (window.sessionStorage.getItem('toast')) {
        const { message, level, options } = JSON.parse(window.sessionStorage.getItem('toast'))
        window.sessionStorage.removeItem('toast')
        window.toast(message, level, options)
    }
})
